<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<div class="d-flex ml-4 mt-n2" style="width: 618px;">
			<v-tabs background-color="deep-purple lighten-3" center-active v-model="tab" dark style="border-radius: 5px 5px 0 0;" active-class="child_active">
				<v-tabs-slider color="deep-purple darken-4"></v-tabs-slider>
				<v-tab>课时账户余额</v-tab>
				<v-tab>课时缴费订单</v-tab>
				<v-tab>课时流水查询</v-tab>
				<v-tab>手工划课订单</v-tab>
				<v-tab>退费订单查询</v-tab>
			</v-tabs>
		</div>
		<v-tabs-items v-model="tab">
			<v-tab-item>
				<!-- 账户余额明细 -->
				<accountList></accountList>
			</v-tab-item>
			<v-tab-item>
				<!-- 课时充值订单查询 -->
				<courseRecharge></courseRecharge>
			</v-tab-item>
			<v-tab-item>
				<!-- 课时账户流水 -->
				<accountJournal></accountJournal>
			</v-tab-item>
			<v-tab-item>
				<!-- 手工划课订单 -->
				<reduceOrderList></reduceOrderList>
			</v-tab-item>
			<v-tab-item>
				<!-- 退费订单 -->
				<refundOrderList></refundOrderList>
			</v-tab-item>
		</v-tabs-items>

	</v-card>
</template>

<script>
	import global from '../../../config/global'
	import accountList from "./student_account_list.vue"
	import courseRecharge from "./course_recharge_list.vue"
	import accountJournal from "./account_journal_list.vue"
	import refundOrderList from "./course_refund_order.vue"
	import reduceOrderList from "./course_reduce_order.vue"
	export default {
		name: "course-account-index",
		components:{accountList,courseRecharge,accountJournal,refundOrderList,reduceOrderList},
		data() {
			return {
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/home/index"
					},
					{
						text: '财务中心',
						disabled: true
					},
					{
						text: '学员课时账户中心',
						disabled: true
					},
				],
				tab:null,
				
				
			}
		},
		created() {
		
		},
		
		methods: {
			
		}
	}
</script>
<style lang="scss" scoped>
	.child_active{
		background-color:#651FFF;
		border-radius: 5px 5px 0 0;	
	}
</style>
